import { useLanguage } from "../../../../context/LanguageContext";
import { Button } from "../../../../components/ui/button";
import { ArrowUpDown, Eye } from "lucide-react";
import { DataTable } from "../../../../components/DataTable";
import { SubLessonData } from "../../../../lib/languages";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";

const TableStudents = ({ data = [] }) => {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];

  const { user } = useAuth();
  const navigate = useNavigate();

  const navigateUrl =
    user?.role === "admin"
      ? "/admin/settings"
      : user?.role === "student"
      ? "/settings"
      : "/teacher/settings";

  const columns = [
    {
      accessorKey: "name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.columnStudentName}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      accessorKey: "email",
      header: t.columnEmailAddress,
    },
    {
      accessorKey: "phone",
      header: t.columnPhone,
    },
    {
      accessorKey: "created_at",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.columnRegisterDate}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      accessorKey: "Actions",
      cell: ({ row }) => {
        return (
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="icon"
              onClick={() =>
                navigate(navigateUrl, {
                  state: { userData: row?.original },
                })
              }
            >
              <Eye className="h-4 w-4" />
            </Button>
            {/* <Button variant="outline" size="sm">
              {t.buttonDelete}
            </Button> */}
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      title={t.tableStudentsTitle}
      filterNames={["title_ar", "title_en"]}
    />
  );
};

export default TableStudents;
